// src/utils/notify.js
// Minimal, central notifier der falder tilbage til dev-log hvis NotificationBar ikke er mounted
import { devLog, devError } from 'utils/devLog';

let _enqueue;

/** Forbind UI'ens enqueue-funktion (f.eks. NotificationBar) */
export function bindNotifier(fn) {
  _enqueue = typeof fn === 'function' ? fn : undefined;
}

export function notifySuccess(message) {
  if (_enqueue) return _enqueue({ type: 'success', message });
  // dev-only fallback uden eslint-no-console støj
  devLog('[SUCCESS]', message);
}

export function notifyError(message) {
  if (_enqueue) return _enqueue({ type: 'error', message });
  devError('[ERROR]', message);
}

export function notifyInfo(message) {
  if (_enqueue) return _enqueue({ type: 'info', message });
  devLog('[INFO]', message);
}
